/** Compatibility export; the business domain owns this implementation. */
export { EnumFlyingGlobalColorOption, EnumFlyingGlobalTypeOption, FLYING_GLOBAL_LISTING_LIMITATIONS, FlyingGlobalListingSchema, IFlyingGlobalListing, IFlyingGlobalOptions, IFlyingGlobalText } from '@domains/upload/shared';
